import { isEmptyObject } from '@wix/editor-elements-common-utils';
import type { MenuItemWithChildren } from '@wix/editor-elements-library/src/components/Menu/Menu.types';

export const calcLastItemWithLinkOrSubItems = (
  menuItems: Array<MenuItemWithChildren>,
) =>
  [...menuItems]
    .reverse()
    .find(item => !!item.items?.length || !isEmptyObject(item.link))?.id;
